import React from 'react';
import { ProviderProjectView } from './ProviderProjectView';

export function InspectorProjectView() {
  return <ProviderProjectView providerType="inspector" />;
}
